import React from 'react';

import { Carousel } from '../Carousel';
import { ProductCarouselProps } from './ProductCarousel.types';
import { ProductCarouselCard } from './ProductCarouselCard';

export function ProductCarousel({
  cards,
  scrollIncrement = 1,
  withControls = true,
  testid = 'product-carousel',
}: ProductCarouselProps): JSX.Element {
  return (
    <Carousel
      className='product-carousel'
      scrollIncrement={scrollIncrement}
      withControls={withControls}
      testid={testid}
    >
      {cards.map((props, cardIndex) => (
        <ProductCarouselCard key={cardIndex} index={cardIndex} {...props} />
      ))}
    </Carousel>
  );
}
